<template>
 <!-- <v-app>-->
  <div id="app">
    <keep-alive>
      <nav-bar></nav-bar>
    </keep-alive>
    <!--  <router-view/>-->
    
  </div>
 <!-- </v-app>-->
</template>

<script>
import nav from './components/Layout.vue';

export default {
  components:{
    'nav-bar': nav
  },

  data: () => ({
    //
  }),
};
</script>
